/*
  Buying guides (sections/nr-main-article.liquid with Style: Buying guide).
  - Comparison tables (.nr-compare) sort by any column: each heading becomes
    a button. Numbers sort as numbers ("£0.33", "1,000 mg"), and a cell with
    no number, such as "Not stated", always goes last. A cell's data-value
    overrides its text. Side-by-side tables (.nr-compare--versus) don't sort.
  - Links to our own products in the body are tagged like the product cards,
    so assets/nr-guide.js traces their clicks back to the article.
  - Links to other sites publish a "nr_blog_outbound_click" customer event,
    which a custom pixel (Settings > Customer events) can pass to GA4.
  Nothing here is needed to read the page.
*/
(function () {
  if (window.nrBuyingGuide) return;
  window.nrBuyingGuide = true;

  var guide = document.querySelector('.nr-guide--buying');
  if (!guide) return;
  var content = guide.querySelector('.nr-guide__content');
  if (!content) return;

  /* ---------- Sorting ---------- */

  function cellValue(cell) {
    if (!cell) return null;
    var raw = cell.dataset.value != null ? cell.dataset.value : cell.textContent;
    var match = raw.replace(/,/g, '').match(/-?\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : null;
  }

  function makeSortable(table) {
    var head = table.tHead && table.tHead.rows[0];
    var body = table.tBodies[0];
    if (!head || !body || body.rows.length < 3) return;

    // Remember the written order, so equal values keep it.
    Array.prototype.forEach.call(body.rows, function (row, index) {
      row.dataset.order = index;
    });

    Array.prototype.forEach.call(head.cells, function (th, column) {
      if (column === 0) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'nr-compare__sort';
      while (th.firstChild) button.appendChild(th.firstChild);
      th.appendChild(button);

      button.addEventListener('click', function () {
        var ascending = th.getAttribute('aria-sort') !== 'ascending';
        Array.prototype.forEach.call(head.cells, function (other) {
          other.removeAttribute('aria-sort');
        });
        th.setAttribute('aria-sort', ascending ? 'ascending' : 'descending');

        var rows = Array.prototype.slice.call(body.rows);
        rows.sort(function (a, b) {
          var x = cellValue(a.cells[column]);
          var y = cellValue(b.cells[column]);
          if (x === null && y === null) return a.dataset.order - b.dataset.order;
          if (x === null) return 1;
          if (y === null) return -1;
          if (x === y) return a.dataset.order - b.dataset.order;
          return ascending ? x - y : y - x;
        });
        rows.forEach(function (row) {
          body.appendChild(row);
        });
      });
    });
  }

  // A side-by-side table (.nr-compare--versus) lists facts in its rows, so it doesn't sort.
  content.querySelectorAll('.nr-compare:not(.nr-compare--versus) table').forEach(makeSortable);

  /* ---------- Links ---------- */

  var article = guide.dataset.article || '';

  function position(link) {
    if (link.closest('.nr-pick')) return 'pick';
    if (link.closest('.nr-compare')) return 'table';
    return 'text';
  }

  // Our own product links: hand them to the product-card tracking in nr-guide.js.
  content.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
    if (link.hostname !== window.location.hostname || link.hasAttribute('data-nr-blog-product')) return;
    var handle = link.pathname.split('/products/')[1];
    if (!handle) return;
    link.setAttribute('data-nr-blog-product', '');
    link.dataset.article = article;
    link.dataset.product = handle.split('/')[0];
    link.dataset.position = position(link);
  });

  content.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || !/^https?:$/.test(link.protocol) || link.hostname === window.location.hostname) return;

    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('nr_blog_outbound_click', {
          article: article,
          destination: link.hostname.replace(/^www\./, ''),
          url: link.href,
          position: position(link),
        });
      }
    } catch (error) {
      /* Tracking must never break the link. */
    }
  });
})();
